export default [
  { key: "en", name: "english" },
  { key: "fi", name: "finnish" },
  { key: "sv", name: "swedish" },
];

export const DEFAULT_LANG = "en";
